import shadowClient from "../lib/clients/shadow/shadowClient";
import Logger from "../lib/Logger";

const logger = new Logger("transformHtml");

export function transformHtml(htmlContent: string, bgColor: string, color: string, toApiString = false): string {

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    const spans = doc.querySelectorAll('span');
    const imgs = doc.querySelectorAll('img');

    if (toApiString) {
        spans.forEach(span => {
            const username = span.textContent?.trim().slice(1);

            const user = Array.from(shadowClient.userStore.users).find(
                    user => user.username === username
            );

            if (user) {
                span.replaceWith(`<@${user.id}>`);
            } else {
                logger.error("Couldn't find user with username" + username);
            }
        });

        imgs.forEach(img => {
            img.replaceWith(img.dataset['tag'] || "");
        })

        doc.querySelectorAll('br').forEach((br) => {
            br.replaceWith(`\n`);
        })

        return doc.body.textContent || "";
    } else {
        spans.forEach(span => {
            span.style.backgroundColor = bgColor;
            span.style.color = color;
        });
        return doc.body.innerHTML;
    }


}
